var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.selectedTab.type == _vm.ItemCategoryTypes.MISC ||
    _vm.selectedViewType != _vm.viewTypes.tabbedView
      ? _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c("quote-builder-misc-headings-component", {
              attrs: {
                name: _vm.miscCategoryObject?.displayName || "Miscellaneous",
                count: _vm.miscLength,
                "total-amount": _vm.MiscTotal,
                "is-full-width": _vm.isFullWidth,
              },
            }),
            _c(
              "div",
              { staticClass: "rows" },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        clone: ($event) =>
                          _vm.cloneHandler($event, _vm.ItemCategoryTypes.MISC),
                        group: {
                          name: _vm.ItemCategoryTypes.MISC,
                          pull: "clone",
                          put: true,
                        },
                        handle: ".item-drag-handle",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.itemMoved(
                            $event,
                            _vm.ItemCategoryTypes.MISC
                          )
                        },
                        over: function ($event) {
                          $event.preventDefault()
                        },
                        enter: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.innerValue.miscs,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "miscs", $$v)
                        },
                        expression: "innerValue.miscs",
                      },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      chosen: "chosen",
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                    },
                    false
                  ),
                  _vm._l(_vm.miscItems, function (item) {
                    return _c("quote-builder-misc-item", {
                      key: item.id,
                      attrs: {
                        "inner-value": _vm.innerValue,
                        "is-full-width": _vm.isFullWidth,
                        "items-assessments": _vm.itemsAssessments,
                        item: item,
                        "edit-item-id": _vm.editItemObj.id,
                        vehicle: _vm.vehicle,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        deleteItem: (item) => _vm.deleteItem(item),
                        focusNextRow: function ($event) {
                          return _vm.$emit("focusNextRow", item)
                        },
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        itemRowClicked: (value, event, close) =>
                          _vm.$emit("handleItemRowClick", value, event, close),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-outlined is-primary",
                  attrs: { disabled: _vm.readOnlyComputed },
                  on: {
                    click: function ($event) {
                      return _vm.addBlankItem()
                    },
                  },
                },
                [_vm._v(" + Add Item ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }